import { Box } from '@mui/material'
import AddLogoDialog from './AddLogoDialog'
import RemoveLogoDialog from './RemoveLogoDialog'
import ImageField from '../files/ImageField'
import { useRecordContext } from 'react-admin'

const Logo = () => {

  const record = useRecordContext()
  if (!record) return null

  return (
    <Box>
      <Box>
        <AddLogoDialog />
      </Box>
      {
        record.logo &&
        <Box>
          <Box>
            <ImageField fileId={record.logo?.id}/>
          </Box>
          <Box>
            <RemoveLogoDialog />
          </Box>
        </Box>
      }
    </Box>
  )
}

export default Logo